__turbopack_context__.v({
  "shippingCalloutBanner--additionalMargin": "styles-module___jADMa__shippingCalloutBanner--additionalMargin",
});
